import { Native } from "../../../native";

/** GGPoker security-measures blog post linked from the desktop notice banner. */
export const GGPOKER_NOTICE_URL =
  "https://ggpoker.com/blog/new-security-measures-at-ggpoker/";

/** Desktop-only gate for the GGPoker safety notice banner. */
export function shouldShowGgpokerDesktopNotice(_isNative: boolean): boolean {
  return false;
}

/** Open an outbound URL via the native shell (required for desktop links). */
export function openNativeExternal(event: MouseEvent, url: string): void {
  event.preventDefault();
  Native.openExternal(url);
}
